"use client";

import React from "react";
import { Play, Film } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function TheCountdownBegins() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224295" id="the-countdown-begins" className="bg-background text-foreground relative flex min-h-[90vh] items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/college_view.png')] bg-cover bg-center opacity-60 mix-blend-multiply grayscale" />
        {}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,var(--color-background)_100%)]" />
        {}
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/60 to-transparent" />
      </div>

      <div ref={ref} className={cn("relative z-10 container mx-auto px-4 py-24 text-center flex flex-col items-center gap-8 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        <span className="inline-flex items-center rounded-md border border-primary/30 bg-primary/10 px-4 py-1.5 text-sm font-default font-medium text-primary backdrop-blur-sm tracking-widest uppercase">
          <Film className="mr-2 size-4" />
          Skyline High Class of 2005
        </span>

        <h1 className="font-default text-5xl sm:text-6xl md:text-[80px] font-extrabold leading-[1.1] tracking-tighter max-w-5xl">
          The Countdown{" "}
          <span className="text-primary drop-shadow-[0_0_15px_rgba(218,165,32,0.5)] font-serif">
            Begins
          </span>{" "}
        </h1>

        <p className="font-default text-lg sm:text-xl md:text-2xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
          Two decades of memories, one unforgettable night. Join your fellow alumni 
          as we celebrate our 20-year journey and reconnect with the friends 
          who made Skyline High feel like home.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 mt-4">
          <Link to="/AlumniRollCallPage">
            <Button size="lg" className="bg-gradient-to-r from-primary to-accent text-primary-foreground hover:opacity-90 shadow-xl shadow-primary/20 h-14 px-8 rounded-md text-lg font-semibold transition-transform hover:scale-105 animate-pulse">
              <Play className="mr-2 size-5 fill-current" />
              Register Now
            </Button>
          </Link>
          
          <Link to="/TheWeekendAgendaPage">
            <Button size="lg" variant="ghost" className="h-14 px-8 rounded-md text-lg font-medium border border-primary/50 hover:bg-primary/10 backdrop-blur-sm transition-colors text-foreground">
              The Weekend Agenda
            </Button>
          </Link>
        </div>

        {}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/10 rounded-md blur-[120px] pointer-events-none -z-10" />
      </div>
    </section>;
}